import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const GiftingBusinessPage = () => {
  return <SanityContentPage slug='gifting-business' />
}

export default GiftingBusinessPage
